import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var TextUppercase = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: cn(styles.textUppercase, className) }, children));
};
export default TextUppercase;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/text/textUppercase.tsx
// module id = TvgL
// module chunks = 2